(function () {
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').
  /*  This uses the angular ui-bootstrap "typeahead" directive option,
      "typeahead-editable='false'", which restricts ng-model values to ones actually
      selected from the popup list.  No other logic is needed to enforce that.
       However, it is desired that the input textbox not retain any values that do not
      correspond to selected items.  Because the "model value" is hidden in the UI, the
      text box is the only feedback that a valid value has been typed & selected.
       This directive uses a second value, "selectedActivity" to record the selected value
      and "activity" is used in logic to clear the textbox contents if they are invalid.
  */
  /*  REQUIRED ATTRIBUTES:
       inputId - allows the controller to provide the id of the input element created by the directive
      selectedActivity - the object that is populated when user selects from the typeahead list.  It must
          be preset to the existing item name when the selector is used to edit an existing item.
       OPTIONAL ATTRIBUTES:
       activityStatus - reference to the function that returns the bootstrap validation classes of
          'has-error', 'has-success', or null.  It can be used for visual validation feedback.
      clearActivity - reference to the directive function that clears both the textbox text and selectedActivity.
      clearButton - if specified, a clear button is added to the input text box when an activity is selected.
          To include the clear button, use the attribute 'clearButton = "true"'.
      isAssessment - boolean value to limit typeahead items to assessment activities; default = false.
      limit - a value that set the number of typeahead items displayed; default = 10.
      onActivitySelected - user provided function that can be used provide additional validation of selectedActivity.
          If supplied, onSelectActivity takes one parameter 'item' and returns true/false or a promise object that
          eventually returns true or false. Example: onActivitySelected = "validateActivity(item)".
      onClearButtonClick - user provided callback to allow clearing of errors when the clear button is clicked.
          Has no effect if clearButton is not true.  Example: onClearButtonClick = "clearErrors()".
      placeholder - string used as a placeholder in the input textbox; default: 'Search by activity name'
           To specify a placeholder, use the attribute placeholder="'your placeholder text'".
  */

  directive('wsActivitySelector', ['$http', '$q', 'Api', 'Demo', '$timeout', 'User', 'Validation', 'QuickFilters', 'Utils', function ($http, $q, Api, Demo, $timeout, User, Validation, QuickFilters, Utils) {
    return {
      scope: {
        inputId: "@",
        selectedActivity: "=",
        activityStatus: "=?",
        clearActivity: "=?",
        clearButton: "=?",
        limit: "=?",
        onActivitySelected: "&?",
        clearActivityOnSelect: "=?",
        onClearButtonClick: "&?",
        placeholder: "=?",
        hideId: "=?",
        isDemoMode: "=?",
        excludeActivities: "<?",
        searchFilter: "=?",
        triggerOpen: "=?",
        searchToggle: "=",
        toggleAttached: "=?",
        referenceType: "<",
        referenceId: "<"
      },
      templateUrl: "modules/common/directives/activity-selector/activity-selector.html",
      link: function link($scope, element, attrs) {
        $scope.limit = $scope.limit || 10;
        $scope.placeholder = $scope.placeholder || 'Search for an activity';
        $scope.toggleAttached = $scope.toggleAttached || false;
        if (!attrs.onActivitySelected) {
          $scope.onActivitySelected = function () {
            return true;
          };
        }
        if (!attrs.onClearButtonClick) {
          $scope.onClearButtonClick = angular.noop;
        }

        //  - hasFocus ensures that activityStatus() reflects validity only when typeahead has focus
        //  - isValid reflects the validity of the current selected value (if any)
        var hasFocus = false;
        var isValid = null;
        var noMatchError = "No matching activities";
        $scope.state = {
          activityQuery: "",
          showMore: false,
          tempLimit: null
        };
        function getActivityQuery() {
          return $scope.state.activityQuery;
        }
        function prepareQuery(q) {
          return q.trim();
        }
        function validateQuery(q) {
          return typeof q === 'string';
        }
        function setActivityQuery(q) {
          $scope.state.activityQuery = validateQuery(q) ? prepareQuery(q) : "";
        }
        function setShowMore(b) {
          $scope.state.showMore = typeof b === 'boolean' && b;
        }
        function isShowMore() {
          return typeof $scope.state.showMore === 'boolean' && $scope.state.showMore;
        }
        function getTempLimit() {
          return typeof $scope.state.tempLimit === 'number' ? $scope.state.tempLimit : undefined;
        }
        function setTempLimit(v) {
          $scope.state.tempLimit = v;
        }
        function clearTempLimit() {
          setTempLimit(null);
        }

        // if selectedActivity fields = "", convert to null
        if (angular.equals($scope.selectedActivity, {
          activityId: "",
          name: ""
        })) {
          $scope.selectedActivity = null;
        }
        $scope.activityStatus = function () {
          if (hasFocus && isValid !== null) {
            return isValid ? "has-success" : "has-error";
          }
          return "";
        };
        $scope.clearActivity = function () {
          delete $scope.selectedActivity;
          $scope.activity = null;
          if (!isShowMore()) {
            setActivityQuery("");
          }
          $scope.errorMsg = null;
          isValid = null;
          $scope.activityTypeahead(getActivityQuery());
        };
        function setActivityFocus() {
          $("#" + $scope.inputId).focus();
        }
        $scope.clearActivityClick = function () {
          if ($scope.clearActivity !== undefined) {
            $scope.clearActivity();
          }
          $scope.onClearButtonClick();
          $timeout(setActivityFocus, 0); // use timeout to set focus on next $apply() cycle
        };

        // watch $scope.activity to catch clearing of input field by deleting its text
        $scope.$watch('activity', function listener(newValue) {
          if (newValue === "") {
            $scope.clearActivityClick();
          }
        });
        $scope.activitySelected = function (item) {
          if (item.query) {
            $scope.activity = item.query;
            setActivityQuery(item.query);
            setShowMore(item.showMore);
            // ngModel.$setViewValue(item.query);
            setTempLimit(100);
            $scope.triggerOpen();
            return;
          }
          clearTempLimit();
          $scope.selectedActivity = item;
          if ($scope.clearActivityOnSelect) {
            $scope.activity = '';
            if (!isShowMore()) {
              setActivityQuery('');
            }
          }

          // call user-provided validation function, a promise
          // var validate = $scope.onActivitySelected({item: item});
          $q.when($scope.onActivitySelected({
            item: item
          })).then(function (result) {
            isValid = result;
          });
        };

        // Enforce that we'll only allow a value to remain in the input field that's
        // actually been selected from the list. "activity" will be undefined
        // or "" if the input text is invalid.
        $scope.activityBlur = function () {
          hasFocus = false; // prevents "late" key events from affecting status
          if ($scope.activity === undefined || $scope.activity === "") {
            if ($scope.clearActivity !== undefined) {
              $scope.clearActivity();
            }
          }
        };
        $scope.activityFocus = function () {
          hasFocus = true;
        };
        $scope.activityTypeahead = function (query) {
          if (!isShowMore()) {
            setActivityQuery(query);
          }
          query = getActivityQuery();
          if (query === undefined) {
            query = "";
          }

          //don't run this logic if org hasn't been selected
          var session = User.get();
          if (session.organization === undefined) {
            return;
          }
          if (!query || !query.length) {
            return;
          }
          if (hasFocus) {
            // indicate "invalid" while typing in input field
            isValid = false;
            delete $scope.selectedActivity;
          }
          var sortParam = QuickFilters.getQuickFilterSortParam($scope.referenceType, $scope.referenceId, {
            itemName: "activities"
          }, Validation.isUrl(query) ? "id" : "name");

          /*jshint camelcase: false */
          var searchParams = {
            searchTerm: query,
            order_by: sortParam,
            searchToggle: $scope.searchToggle,
            _limit: getTempLimit() || $scope.limit,
            demo: Demo.isDemoMode()
          };
          /*jshint camelcase: true */

          if ($scope.searchFilter) {
            _.extend(searchParams, $scope.searchFilter);
          }
          if ($scope.referenceType) {
            searchParams[$scope.referenceType] = $scope.referenceId;
          }
          var excludeActivities = _.flatten($scope.excludeActivities);
          if (excludeActivities && excludeActivities.length) {
            if (typeof excludeActivities[0] === 'string') {
              searchParams.exclude = excludeActivities;
            } else {
              searchParams.exclude = _.pluck(excludeActivities, 'activityId');
            }
          }

          // This endpoint search within name, description and activityId
          return $http.get(Api.url('/acc/activities/search'), {
            params: searchParams
          }).then(function activitySearchSuccess(response) {
            if (response.data.results.length > 0) {
              $scope.errorMsg = null;
              var res = response.data.results;
              var results = _.map(res, function (result) {
                return {
                  activityId: result.activityId,
                  name: Utils.coalesceActivity(result),
                  description: result.description,
                  isAssessment: result.assessment
                };
              }).slice(0, getTempLimit() || $scope.limit);

              //pull out assessments from activities and add group types
              var assessments = _.filter(results, function (item) {
                return item.isAssessment === true;
              });
              if (assessments.length > 0) {
                assessments[0].groupType = "Assessments";
              }
              var activities = _.filter(results, function (item) {
                return item.isAssessment === false;
              });
              if (activities.length > 0) {
                activities[0].groupType = "Activities";
              }
              if (response.data.count > activities.length && activities.length > 0 && !getTempLimit()) {
                activities.push({
                  name: 'Show more results',
                  showMore: true
                });
              }
              return assessments.concat(activities);
            }

            // default - no matching items found
            isValid = false;
            $scope.errorMsg = noMatchError;
            return [];
          }).then(function (results) {
            setShowMore(false);
            clearTempLimit();
            return results;
          });
        };

        // set initial view of selector textbox & check for results/validity
        $scope.activity = $scope.selectedActivity ? $scope.selectedActivity.name : "";
        $scope.activityTypeahead($scope.selectedActivity ? $scope.selectedActivity.activityId : "");
      }
    };
  }]);
})();
